<div class="c-portlet o-block u-width-100p _u-width-100p u-bg-primary {{ sectionclass }}">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div>
		<a
			href="#"
			class="datatable_download_icon"
			*ngIf="hasData && downloadConfiguration && downloadConfiguration.enableDownload"
			(click)="downloadCSV()"
			target="_blank"
		>
			<img class="downloadIcon" src="../../../../../assets/creative-assets/download.svg" />
		</a>
	</div>
	<div *ngIf="hasData">
		<div class="unique_reach_frequency">
			<div class="campaigns-toggle">
				<div class="creative-card-name">
					<h2 id="creativeName" class="creativeNameDropdown"></h2>
					<ng-select
						[items]="campaignsList"
						bindLabel="name"
						[title]="campaignCarouselItem.name"
						[(ngModel)]="campaignCarouselItem.name"
						(change)="changeCampaignData($event)"
					>
					</ng-select>
				</div>
				<div class="header">Trailing 30-day Household Reach & Frequency</div>
				<div class="lifetime-chart">
					<div *ngIf="campaignCarouselItem.showChart; else elseBlockHideChart" class="" style="min-height: 200px">
						<app-chart
							class="individual-chart"
							[setcolor]="customchartconfiguration.setGraphBackgroundColor"
							[chartData]="campaignCarouselItem"
						></app-chart>
					</div>
					<ng-template #elseBlockHideChart>
						<div class="individual-chart">
							<p class="no-data-selected-date">No Data Available</p>
						</div>
					</ng-template>
				</div>
			</div>
			<div class="campaign-data">
				<div class="lifetime-average">
					<div class="lifetime-average-title">Lifetime Campaign Average</div>

					<div *ngFor="let avg of campaignCarouselItem.averageLifetimes">
						<div class="lifetime-average-metric">
							<div class="metric-value" [ngClass]="{ 'normal-font-weight': avg.isNonZeroValue }">
								{{ avg.parameterValue }}
							</div>
							<div class="metric-title">
								{{ avg.parameterName }}
							</div>
						</div>
					</div>
				</div>
				<!-- check buttons section header -->
				<div class="checkbox-section-name" *ngIf="seriesviewconfiguration.checkboxGroupSectionName">
					{{ seriesviewconfiguration.checkboxGroupSectionName }}
				</div>
				<!-- checkboxes -->
				<div class="checkbox-group-container" *ngIf="seriesviewconfiguration.checkboxButtons">
					<span class="span-checkbox-container">
						<label
							for="{{ nameSpace }}-checkbox-{{ button.seriesId }}"
							class="checkbox-container {{ button.color }}"
							*ngFor="let button of seriesviewconfiguration.checkboxButtons"
						>
							<input
								type="checkbox"
								id="{{ nameSpace }}-checkbox-{{ button.seriesId }}"
								value="{{ button.seriesId }}"
								[checked]="button.visible"
								(change)="toggleSeriesVisiblityByCheckbox($event.target.value)"
							/>
							<span class="checkbox-button"></span>
							<span class="checkbox-text">{{ button.displayName }}</span>
						</label>
						<div class="legendTooltip-container">
							<div class="tooltipText">
								Trailing 30-day uniques refers to the total number of households that were shown an ad on a given day
								over the past 30 days.
							</div>
							<div class="tooltip-pointer"></div>
						</div>
					</span>
				</div>

				<!-- radion buttons with sections -->
				<div class="section-name" *ngIf="seriesviewconfiguration.radioGroupSectionName">
					{{ seriesviewconfiguration.radioGroupSectionName }}
				</div>
				<div
					class="radio-container {{ radioButton.color }}"
					*ngFor="let radioButton of seriesviewconfiguration['radioButtonGroup']; let radioButtonId = index"
				>
					<span class="span-checkbox-container">
						<label for="{{ nameSpace }}-radio-button-{{ radioButtonId }}">
							<input
								id="{{ nameSpace }}-radio-button-{{ radioButtonId }}"
								type="radio"
								name="{{ nameSpace }}-button-group"
								[value]="radioButtonId"
								[checked]="selectedRadioButtonId === radioButtonId"
								(change)="updateSeriesVisibilityByRadioButton($event.target.value)"
							/>
							<span class="radio-text">{{ radioButton.displayName }}</span>
						</label>
						<div class="legendTooltip-container">
							<div class="tooltipText">
								Trailing 30-day frequency refers to the number of times a household was exposed to an ad on a given day
								over the past 30 days.
							</div>
							<div class="tooltip-pointer"></div>
						</div>
					</span>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="!hasData" class="no-reach-frequency">
		<div class="no-data-text">No Data Available</div>
	</div>
</div>
